import { FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { FieldSkeleton } from '../FieldSkeleton/FieldSkeleton';

import {
  BuildingSelect,
  BuildingSelectItem,
  BuildingSelectProps,
} from './BuildingSelect';

export interface FormBuildingSelectProps
  extends Omit<BuildingSelectProps, 'building' | 'onChange'> {
  name: string;
  onChange?: (value: BuildingSelectItem | undefined) => void;
  loading?: boolean;
}

export const FormBuildingSelect: FC<FormBuildingSelectProps> = ({
  name,
  required,
  onChange,
  loading,
  ...rest
}) => {
  const validate = useCallback(
    (value: BuildingSelectItem | undefined) => {
      if (required && value === undefined) return 'Заполните поле';

      return '';
    },
    [required],
  );

  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (value: BuildingSelectItem | undefined) => {
      input.onChange(value);
      onChange?.(value);
    },
    [input, onChange],
  );

  return loading ? (
    <FieldSkeleton />
  ) : (
    <BuildingSelect
      building={input.value}
      {...rest}
      required={required}
      error={!!error}
      helperText={error}
      onChange={handleChange}
    />
  );
};
